import { useIntl } from 'react-intl';

import { t } from '../utils/translate';
import styles from './PeriodPills.module.less';

interface Props {
  value: number;
  options: number[];
  onChange: (next: number) => void;
}

export function PeriodPills({ value, options, onChange }: Props) {
  const intl = useIntl();
  return (
    <div className={styles.row}>
      <label className={styles.label}>
        {t(intl, 'calculator.loanPeriod')}
      </label>
      <div
        className={styles.pills}
        role="radiogroup"
        aria-label={t(intl, 'calculator.loanPeriod')}
      >
        {options.map(opt => {
          const active = opt === value;
          return (
            <button
              type="button"
              key={opt}
              role="radio"
              aria-checked={active}
              className={`${styles.pill} ${active ? styles.pillActive : ''}`}
              onClick={() => onChange(opt)}
            >
              {t(intl, 'calculator.months', { months: opt })}
            </button>
          );
        })}
      </div>
    </div>
  );
}
